module.exports = __webpack_public_path__ + "b35a4ed9613acafc10c429ac803e7fed.pdf";